
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"50","viewBox":"0 0 50 50","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.0397 0C9.41974 0 0.000262996 9.42062 0 21.0399C0 32.6592 9.41974 42.0798 21.0397 42.0798C25.8702 42.0798 30.4034 40.3729 33.9549 37.6351L45.4489 49.2307C46.4762 50.2564 48.2025 50.2564 49.2298 49.2307C50.2568 48.2024 50.2568 46.4772 49.2298 45.4488L37.6421 33.94C40.3794 30.3895 42.0794 25.8712 42.0794 21.0399C42.0794 9.42062 32.6597 0 21.0397 0ZM21.0397 5.25998C29.7546 5.25998 36.8192 12.3241 36.8195 21.0399C36.8195 29.7557 29.7546 36.8198 21.0397 36.8198C12.3248 36.8198 5.26019 29.7557 5.25992 21.0399C5.25992 12.3241 12.3248 5.25998 21.0397 5.25998ZM21.0397 13.1499C19.5872 13.1499 18.4097 14.3282 18.4097 15.7799V18.4099H15.7798C14.3272 18.4099 13.1498 19.5882 13.1498 21.0399C13.1498 22.4917 14.3272 23.6699 15.7798 23.6699H18.4097V26.2999C18.4097 27.7516 19.5872 28.9299 21.0397 28.9299C22.4922 28.9299 23.6697 27.7516 23.6697 26.2999V23.6699H26.2996C27.7522 23.6699 28.9296 22.4917 28.9296 21.0399C28.9296 19.5882 27.7522 18.4099 26.2996 18.4099H23.6697V15.7799C23.6697 14.3282 22.4922 13.1499 21.0397 13.1499Z","fill":"#2A343D","fill-opacity":"0.45"}})])
          )
        }
      }
    